import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// importing Material UI
import { 
    AppBar, Toolbar, Typography, IconButton, Select, MenuItem, Box, Divider, useMediaQuery,
    Button, Dialog, InputAdornment, Avatar, Drawer, List, ListItem, ListItemText, ListItemButton,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';

import { useTheme } from '@mui/material/styles';

import UserMenu from './UserMenu';
import LoginForm from '../login_system/LoginForm';
import SignUpForm from '../login_system/SignUpForm';
import ResetPasswordForm from '../login_system/ResetPasswordForm';
import { useThemeContext } from '../../styles/ThemeContext';
import * as CONSTANTS from "../../constants"

import {
    check_admin_event,
    renew_access_token,
} from '../../services/login_system'

export default ({lang, handleDrawerOpen}) => {

    const { darkMode,  } = useThemeContext();

    if (!Cookies.get('accessToken')) {
        localStorage.removeItem('username');
        localStorage.removeItem('email');
        localStorage.removeItem('is_admin');
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    const [menuLang, setMenuLang] = React.useState(lang);
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [accessToken, setAccessToken] = React.useState(Cookies.get('accessToken')|| null);
    const [refreshToken, setRefreshToken] = React.useState(Cookies.get('refreshToken') || null);
    const [username, setUsername] = React.useState(localStorage.getItem('username'));
    const [email, setEmail] = React.useState(localStorage.getItem('email'));
    const [loginFormMode, setLoginFormMode] = React.useState('Login');

    const closeDialog = () => {
        setIsDialogOpen(false);
    }
    const updateAuth = (username, email) => {
        if (accessToken !== undefined) setAccessToken(Cookies.get('accessToken'));
        if (refreshToken !== undefined) setRefreshToken(Cookies.get('refreshToken'));
        if (username !== undefined) setUsername(username);
        if (email !== undefined) setEmail(email);
        window.location.reload();
    }

    const openLoginDialog = () => {
        setLoginFormMode('Login');
        setIsDialogOpen(true);
    }

    const openSignUpDialog = () => {
        setLoginFormMode('Sign Up');
        setIsDialogOpen(true);
    }

    // Navigation
    const navigate = useNavigate();
    const navigateHome = () => {
        navigate(`/${menuLang}/`);
    }

    const navigatePage = (event) => {
        setMenuLang(event.target.value);
        let newPath = event.target.value+window.location.pathname.substring(
            3, window.location.pathname.length 
        ) + window.location.search
        navigate(`/${newPath}`);
    }
    const navigatePage_lang = (value) => {
        setMenuLang(value);
        let newPath = value+window.location.pathname.substring(
            3, window.location.pathname.length 
        ) + window.location.search
        navigate(`/${newPath}`);
    }

    useEffect(() => {
        async function checkIsAdmin(){
            if (accessToken) {
                const is_admin = await check_admin_event(accessToken);
                if (is_admin === true) {
                    localStorage.setItem('is_admin', is_admin);
                    return;
                }
            }
            const newAccessToken = await renew_access_token(refreshToken); // maybe token expire and retry
            if (newAccessToken === null) {
                localStorage.removeItem('is_admin');
            } else {
                const is_admin = await check_admin_event(newAccessToken);
                localStorage.setItem('is_admin', is_admin);
            }
        }
        checkIsAdmin();
    }, [accessToken]);
    
    useEffect(()=>{
        setAccessToken(
            Cookies.get("accessToken")
        );
        setRefreshToken(
            Cookies.get("refreshToken")
        );
    }, [])

    useEffect(() => {
        if (username) {
            localStorage.setItem('username', username);
        } else{
            localStorage.removeItem('username');
        }
    }, [username]);

    useEffect(() => {
        if (email) {
            localStorage.setItem('email', email);
        } else{
            localStorage.removeItem('email');
        }
    }, [email]);

    const logoutEvent = () => {
        ["accessToken", "refreshToken"].forEach(cookieName => {
            Cookies.remove(cookieName, {path: '/'})
        })
        setUsername(null);
        setAccessToken(null)
        setRefreshToken(null);
        ["email", "username"].forEach(key => {
            localStorage.removeItem(key);
        });
        window.location.reload();
    }
    const settingEvent = () => {
        navigate(`/${lang}/user-setting/`);
    }
    const profileEvent = () => {
        navigate(`/${lang}/user-profile/`);
    }

    // Mobile version only
    const [langDrawerOpen, setLangDrawerOpen] = useState(false);

    return (
        <>
            <AppBar position="fixed" color="inherit" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Box
                        sx={{
                            display: !isMobile? "none": "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={()=>{handleDrawerOpen(); setLangDrawerOpen(false);}}
                            edge="start"
                            sx={{
                                mr: 2,
                                display: !isMobile? "none": "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <MenuIcon sx={{ fontSize: 30 }}/>
                        </IconButton>
                    </Box>
                    <IconButton edge="start" color="inherit" onClick={() => navigateHome()} style={{ marginRight: '10px'}}>
                        <Typography variant="h6" sx={{ flexGrow: 1, display: !isMobile? "unset":"none" }}>
                            WOTAGEI ZONE
                        </Typography>
                    </IconButton>
                    <Box 
                        display="flex" 
                        alignItems="center" 
                        p={1}
                        sx={{ marginLeft: 'auto' }}
                    >   
                        <Box
                            display="flex"
                            alignItems="center"
                            mr={!isMobile? 2: 0}
                        >
                            {
                                username? 
                                <UserMenu 
                                    lang={lang}
                                    username={username}
                                    profileEvent={profileEvent}
                                    settingEvent={settingEvent}
                                    logoutEvent={logoutEvent}
                                /> 
                                :
                                <>
                                    <Avatar 
                                        variant="soft"
                                        children={<AccountCircleIcon/>}
                                        sx={{ 
                                            width: 30, 
                                            height: 30,
                                        }}
                                    />
                                    <Button 
                                        sx={{
                                            ml: !isMobile? 1: 0,
                                            padding: 1,
                                            minWidth: 'auto', 
                                            minHeight: 'auto',
                                        }}
                                        onClick={() => openLoginDialog()}
                                    >
                                        <Typography
                                            color={darkMode? 'white': 'black'}
                                            fontWeight='bold'
                                            fontSize={isMobile? '15px': '18px'}
                                            sx={{
                                                textTransform: 'capitalize'
                                            }}
                                        >
                                            {CONSTANTS.APP_BAR.LOGIN[lang]}
                                        </Typography>
                                    </Button>
                                    <Button 
                                        sx={{
                                            mr: !isMobile? 1: 0, 
                                            padding: 1,
                                            minWidth: 'auto', 
                                            minHeight: 'auto',
                                        }}
                                        onClick={() => openSignUpDialog()}
                                    >
                                        <Typography
                                            color={darkMode? 'white': 'black'}
                                            fontWeight='bold'
                                            fontSize={isMobile? '15px': '18px'}
                                            sx={{
                                                textTransform: 'capitalize'
                                            }}
                                        >
                                            {CONSTANTS.APP_BAR.REGISTER[lang]}
                                        </Typography>
                                    </Button>
                                </>
                            }
                        </Box>
                        <Divider 
                            orientation="vertical" 
                            flexItem 
                            sx={{
                                display: !isMobile? "unset": "none" 
                            }}
                        />
                        <Box
                            sx={{
                                display: !isMobile? "none": "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <IconButton
                                onClick={()=>{setLangDrawerOpen(!langDrawerOpen); handleDrawerOpen(false)}}
                                sx={{
                                    display: !isMobile? "none": "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <LanguageIcon sx={{ fontSize: 30 }} />
                            </IconButton>
                        </Box>
                        <Box 
                            ml={!isMobile? 2: 0}
                            sx={{ display: !isMobile? "unset": "none" }}
                        >
                            <Select
                                value={menuLang}
                                onChange={navigatePage}
                                disableUnderline={true}
                                variant='standard'
                                startAdornment={
                                    <InputAdornment position="start">
                                    <LanguageIcon />
                                    </InputAdornment>
                                }
                            >
                                {
                                    CONSTANTS.LANGUAGE_LIST.map((langItem) => {
                                        return (
                                            <MenuItem key={langItem} value={langItem}>{CONSTANTS.APP_BAR.LANGUAGE_OPTION[langItem]}</MenuItem>      
                                        )
                                    })
                                }
                            </Select>
                        </Box>
                    </Box>
                </Toolbar>
                <Dialog 
                    open={isDialogOpen} 
                    onClose={closeDialog}
                >
                    {
                        {
                            'Login': <LoginForm lang={lang} onClose={closeDialog} updateAuth={updateAuth} setLoginMode={setLoginFormMode} />,
                            'Sign Up': <SignUpForm lang={lang} onClose={closeDialog} setLoginMode={setLoginFormMode} />,
                            'Reset Password': <ResetPasswordForm lang={lang} onClose={closeDialog} setLoginMode={setLoginFormMode} />
                        }[loginFormMode]
                    }
                </Dialog>
                
            </AppBar>

            <Drawer
                variant="temporary"
                anchor="top"
                open={langDrawerOpen}
                onClose={()=> {setLangDrawerOpen(false)}}
                sx={{
                    width: "100%"
                }}
            >
                <Toolbar/>
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        {
                            CONSTANTS.LANGUAGE_LIST.map((langItem) => {
                                return (
                                    <ListItem disablePadding>
                                        <ListItemButton onClick={() => {navigatePage_lang(langItem)}}>
                                            <ListItemText primary={CONSTANTS.APP_BAR.LANGUAGE_OPTION[langItem]} />
                                        </ListItemButton>
                                    </ListItem>    
                                )
                            })
                        }
                    </List>
                </Box>
            </Drawer>
        </>
        
    );
}